import { takeLatest } from 'redux-saga/effects';
import { FETCH_APPOINTMENT_DETAILS_REQUEST } from '../../redux/modules/appointmentDetails/appointmentDetails-actions';
import getAppointmentDetailsWorker from './appointmentDetailsWorkerSaga';

export default function* getAppointmentDetailsWatcher() {
    yield takeLatest(FETCH_APPOINTMENT_DETAILS_REQUEST, getAppointmentDetailsWorker);
}
